module.exports = __webpack_public_path__ + "img/Tchnics1210_arm.9d81dd43.png";